import { api } from '../../../shared/api/client';
import {
  type ListEnvelope,
  normalizeListEnvelope,
  toGenexusParams,
} from '../../../shared/api/genexus-query';
import type { CrudApi } from '../../../shared/api/crud-hooks';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import type { FeriadoDto, FeriadoInput, FeriadoListItem } from './types';

const BASE = '/v1/holidays';

/**
 * Cargos usa PK number; Feriado usa PK Date (string ISO `YYYY-MM-DD`).
 * O DataGrid exige `id` na linha — exposto via campo extra na listItem.
 */
type FeriadoListItemWithId = FeriadoListItem & { id: string };

function withId(row: FeriadoListItem): FeriadoListItemWithId {
  return { ...row, id: row.data };
}

export const feriadosApi: CrudApi<FeriadoListItemWithId, FeriadoDto, FeriadoInput, string> = {
  async list(query: DataTableQuery): Promise<ListEnvelope<FeriadoListItemWithId>> {
    const { data } = await api.get<{
      data: FeriadoListItem[];
      meta: { total: number; pagina?: number; porPagina?: number };
    }>(BASE, { params: toGenexusParams(query) });
    return normalizeListEnvelope({ data: data.data.map(withId), meta: data.meta });
  },

  async get(id: string): Promise<FeriadoDto> {
    const { data } = await api.get<{ data: FeriadoDto }>(`${BASE}/${id}`);
    return data.data;
  },

  async create(input: FeriadoInput): Promise<FeriadoDto> {
    const { data } = await api.post<{ data: FeriadoDto }>(BASE, input);
    return data.data;
  },

  async update(id: string, input: FeriadoInput): Promise<FeriadoDto> {
    const { data } = await api.put<{ data: FeriadoDto }>(`${BASE}/${id}`, input);
    return data.data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`${BASE}/${id}`);
  },
};
